import { Provider } from 'react-redux';
import { Layout } from './pages/layout/Layout';
import { store } from './redux';

export const App = () => {
    return (
        <Provider store={store}>
            <Layout />
        </Provider>
    );
}
